import React from "react";
import { MediaLibrary } from "../../Components/MediaLibrary";
import { usePageHeader } from "../../hooks/usePageHeader";

/**
 * Page Stockage : simple hôte de la Médiathèque en mode « manage » (URL synchronisée, panneau
 * de détail, upload, actions bulk, vue orphelins). Toute la logique vit dans
 * Components/MediaLibrary : le même composant se monte en mode « pick » dans les sélecteurs.
 */
const Storage: React.FC = () => {
	usePageHeader({ title: "Stockage" });
	return <MediaLibrary mode="manage" />;
};

export default Storage;
